import React, { useState, useEffect, useReducer, useRef } from "react";
import "./Profile.css";
import FadeIn from "react-fade-in";
import Switch from "react-switch";
import { useUserStore } from "../../stores";
import constants from "../../utils/constants"
import { ToastContainer, toast } from "react-toastify";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { handleXhrError } from "../../utils";
const toastOptions = {
  position: "top-center",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
};
const MySwal = withReactContent(Swal);

const ROLES = constants().ROLES;
const resizeImage = (url) => {
  return url.split("=")[0] + "=s1024-p";
}
const Profile = () => {
  const userdata = useUserStore((state) => state.data)
  const [name, setName] = useState(userdata.firstName + (userdata.lastName || ""));
  const fullNameRef = useRef();
  const emailRef = useRef();
  const pass = useRef(null);
  const cpass = useRef();
  const reducer = (state, action) => {
    return { ...state, ...action };
  };
  const [user, dispatchUser] = useReducer(reducer, {
    name: "",
    img: "",
    email: "",
    password: "",
    cpassword: "",
    changePassword: false,
  });
  const profileHandle = (e) => {
    e.preventDefault()
    const data = {
      firstName: fullNameRef.current.value,
      lastName: " "
    }
    if (user.changePassword) {
      if (!pass.current.value || pass.current.value.length < 6) {
        alert("Password must be of 6 chars");
        return;
      }
      if (pass.current.value !== cpass.current.value) {
        alert("Please confirm password");
        return;
      }
      data.password = pass.current.value;
    }
    window.$.ajax({
      type: "put",
      url: "/api/verify",
      xhrFields: {
        withCredentials: true,
      },
      data: data,
      dataType: "json",
      success: (response, textStatus, request) => {
        console.log(response);
        console.log("success")
        MySwal.fire("Profile successfully updated");
        pass.current.value = "";
        cpass.current.value = "";
        dispatchUser({ changePassword: !user.changePassword })
      },
      statusCode: {

        404: function () {
          // e.target.disabled = false;
          toast.error("page not found", toastOptions);
        },
        400: function (res) {
          // e.target.disabled = false;
          if (!res.responseJSON) {
            toast.error("Something went wrong...", toastOptions);
            return;
          }

          toast.error(res.responseJSON.message, toastOptions);
          return;
        },
      },
      headers: {
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "",
      },
      error: function (res, textStatus, err) {
        handleXhrError(res, textStatus, err, () => {
          // e.target.disabled = false;
        })
      },
    });
  }
  const About = () => {
    if (userdata.role === ROLES.CO) {
      return <div className="proinfo">{"Co-ordinator"}|{" " + userdata.section.branch.name + " "}|{" " + userdata.email}</div>
    }

    if (userdata.role === ROLES.ADMIN) {
      return <>{" Admin "}|{" " + userdata.email}</>
    }

    if (userdata.role === ROLES.FACULTY) {
      return <>{" Faculty "}|{" " + userdata.email}</>
    }

    if (userdata.role === ROLES.SUPER_ADMIN) {
      return <>{userdata.role + " "}|{" SNIST "}|{" " + userdata.email}</>
    }

    if (userdata.role === ROLES.STUDENT) {
      return <>{" Student "}|{" " + userdata.email}</>
    }
  }
  return (
    <div className="mainprofile">
      {/* <ToastContainer /> */}
      <div className="profilecontainer col-md-6 col-12">
        <img
          className="profilePhoto"
          alt="User"
          referrerPolicy="no-referrer"
          src={userdata.profilePhoto ? resizeImage(userdata.profilePhoto) : "/images/profile.jpg"}
        />
        <h2>{name} </h2>
        <h5 className="grey">
          {About()}
        </h5>
        <form className="col-12">
          <div class="form-group">
            <label for="FullName">Full name</label>
            <input
              type="text"
              ref={fullNameRef}
              class="form-control"
              id="fullName"
              placeholder="Full name"
              value={name}
              onChange={(e) => setName(e.target.value)}
            ></input>
          </div>
          <div class="form-group">
            <label for="Email">Email</label>
            <input
              disabled
              type="email"
              ref={emailRef}
              class="form-control"
              id="email"
              placeholder="Enter email"
              value={userdata.email}
            ></input>
          </div>
          <div className="row mt-2 switchbtn">
            <label
              style={{
                color: "black",
                marginRight: "5px",
                width: "max-content"
              }}
            >
              Change password
            </label>
            <span style={{ width: "auto" }}>
              <Switch
                onChange={(e) =>
                  dispatchUser({ changePassword: !user.changePassword })
                }
                checked={user.changePassword}
              />
            </span>
          </div>
          {!user.changePassword ? (
            <></>
          ) : (
            <FadeIn>
              <div class="form-group">
                <label for="Password">New password</label>
                <input
                  type="password"
                  class="form-control"
                  id="newpassword"
                  placeholder="Enter password"
                  ref={pass}
                ></input>
              </div>
              <div class="form-group">
                <label for="ConfirmPassword">Confirm password</label>
                <input
                  type="password"
                  class="form-control"
                  id="confirmpassword"
                  placeholder="Re-enter password"
                  ref={cpass}
                ></input>
              </div>
            </FadeIn>
          )}
          <div style={{ display: "flex", justifyContent: "center" }}>
            <button type="submit" class="addSectionbtn col-md-4 mt-4 mb-3" onClick={profileHandle} >
              SAVE
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Profile;
